<template>
  <div class="about-us-mobile">
    <banner-c></banner-c>
    <div class="gsjs">
      <div class="title-font-style-m">公司介绍</div>
      <div class="content">
        <div>上海凝丰智能科技有限公司伴随着2016中国VR元年应势而生，作为国内元宇宙生态服务的先行者，持续深耕前沿科技产品趋势、技术、营销和服务，在整合提升产业链价值的过程中，已迭代为“数智化生态服务商”，为上下游企业提供所需的渠道开拓、产品分销、技术研发、数智化解决方案等服务，释放生态互联价值，成为企业实现数智化增长的可靠伙伴。</div>
        <div>凝丰智能总部位于上海，目前数智化营销渠道已覆盖全国，在元宇宙XR领域的市场份额和合作伙伴数量均处于国内领先地位，分销品类正向数智类全面扩容。其自研的元宇宙数实融合技术已申请多项国家专利和商标，以专业的硬件搭载领先的自研技术，面向工业、文娱、教育等各个领域提供一站式数智化前沿解决方案，让科技转化成现实价值。</div>
      </div>
      <div class="gsjs-img">
        <img :src="loadUrl.gsjs" />
      </div>
    </div>
    <div class="szlc-box">
      <div class="title-font-style-m">发展历程</div>
      <div class="szlc">
        <img :src="loadUrl.fzlc_bg" />
        <div class="development-line">
          <div v-for="(item, index) in years" :key="index" :class="active_f_i == index ? 'active-f' : ''">
            <div @click="active_f_i = index"></div>
            <div @click="active_f_i = index">{{ item.name }}</div>
          </div>
        </div>
      </div>
      <div class="szlc-content">
        <div>{{ years[active_f_i].name }}</div>
        <div class="szlc-content-text">
          <div v-for="(item, index) in years[active_f_i].content" :key="index"
            :style="{ color: item.color || '#333', display: item.inlineBlock ? 'inline-block' : '' }">
            <span v-html="item.text"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="ryzz honor">
      <div class="title-font-style-m">荣誉资质</div>
      <div class="prev" @click="prevEvent"></div>
      <div class="next" @click="nextEvent"></div>
      <div class="ryzz-list">
        <el-carousel
          ref="honorsCarouselRef"
          trigger="click"
          arrow="never"
          indicator-position="none"
          :autoplay="true"
          :interval="3000"
          :loop="true"
          :pause-on-hover="false"
          height="340rem"
          type="card"
        >
          <el-carousel-item v-for="(item, index) in honors" :key="item.url + index">
            <div class="honor-card">
              <img :src="item.url" />
              <div>
                <div v-for="(e, i) in item.illustrate" :key="i">{{ e }}</div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="qywh">
      <div class="title-font-style-m">企业文化</div>
      <div class="qywh-content">
        <img :src="loadUrl.qywh_bg" />
        <div>
          <div class="q1">
            <img :src="loadUrl.shiming" />
            <span>使命</span>
          </div>
          <div class="q2">推动元宇宙科学技术进步，促进社会数智化发展</div>
          <div class="q1">
            <img :src="loadUrl.yuanjing" />
            <span>愿景</span>
          </div>
          <div class="q2">成为全球最具价值元宇宙生态服务商</div>
          <div class="q1">
            <img :src="loadUrl.jiazhiguan" />
            <span>价值观</span>
          </div>
          <div class="q2">诚信守诺、持续奋斗、执行第一、成就员工、合作伙伴至上</div>
        </div>
      </div>
    </div>
    <div class="lxwm">
      <div class="title-font-style-m">联系我们</div>
      <div class="lxwm-content">
        <div>
          <div class="s1">上海</div>
          <div class="s2" style="color: #D71819">上海总部</div>
          <div class="s3">上海市徐汇区钦州北路1001号光启园7号楼6层</div>
          <!-- <div class="s3">邮编：518054</div> -->
          <div class="s3">总机电话：400-900-6269</div>
        </div>
        <div>
          <div class="s1">北京</div>
          <div class="s2">北京分公司</div>
          <div class="s3">张僚</div>
          <!-- <div class="s3">邮编：518054</div> -->
          <div class="s3">18035958866</div>
        </div>
        <div>
          <div class="s1">西安</div>
          <div class="s2">西安分公司</div>
          <div class="s3">顾凯</div>
          <!-- <div class="s3">邮编：518054</div> -->
          <div class="s3">15214330809</div>
        </div>
      </div>
    </div>
    <div class="zmt">
      <div class="title-font-style-m">自媒体账号</div>
      <div class="zmt-content">
        <div>
          <div>
            <img :src="loadUrl.gongzhonghao" />
            <span>公众号</span>
          </div>
          <div>
            <img :src="loadUrl.shipinhao" />
            <span>视频号</span>
          </div>
        </div>
        <div>
          <div>
            <img :src="loadUrl.douyin" />
            <span>抖音</span>
          </div>
          <div>
            <img :src="loadUrl.xiaohongshu" />
            <span>小红书</span>
          </div>
        </div>
        <div>
          <div>
            <img :src="loadUrl.bilibili" />
            <span>bilibili</span>
          </div>
          <div>
            <img :src="loadUrl.weibo" />
            <span>微博</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { ref, onMounted } from 'vue'
import type { CarouselInstance } from 'element-plus'
import BannerC from '@/components/BannerC.vue';
import { asynchronousRetrieval } from '@/utils'
import { ElCarousel, ElCarouselItem } from 'element-plus'
const loadUrl: any = ref({})

const years: any = [
  {
    name: '2016',
    content: [
      {
        text: '2016是中国VR元年 凝丰智能应势而生',
      },
      {
        text: '瞄准前瞻市场快速推进业务'
      },
    ]
  },
  {
    name: '2017',
    content: [
      {
        text: '布局线上营销网络'
      },
      {
        text: '与当时VR领头羊品牌HTC VIVE合作签约'
      }
    ]
  },
  {
    name: '2018',
    content: [
      {
        text: '开始布局全国行业渠道网络'
      }
    ]
  },
  {
    name: '2019',
    content: [
      {
        text: '深度融合元宇宙生态'
      },
      {
        text: '为行业赋能解决方案新价值'
      }
    ]
  },
  {
    name: '2020',
    content: [
      {
        text: '跃居XR领域头部公司'
      },
      {
        text: '<span>与一线品牌商合作突破 </span><span class="blods">30家</span>',
      },
      {
        text: '<span>建立起渠道合作伙伴近 </span><span class="blods">1000家</span>',
      },
      {
        text: '<span>线上服务客户突破 </span><span class="blods">百万</span>',
      }
    ]
  },
  {
    name: '2021',
    content: [
      {
        text: '<span class="blods">整体营收破亿 </span><span>企业快速稳健发展</span>'
      },
      {
        text: '高速发展备受资本市场关注',
      },
      {
        text: '在行业数智化领域沉淀技术',
      }
    ]
  },
  {
    name: '2022',
    content: [
      {
        text: '成立研发团队'
      },
      {
        text: '<span>着重深耕 </span><span class="blods">数智化底层技术研发</span>'
      },
      {
        text: '同年6月 完成天使轮融资',
        color: '#D71819'
      }
    ]
  },
  {
    name: '2023',
    content: [
      {
        text: '元宇宙虚实融合应用平台（混空系统 Mixed Space）发布'
      },
      {
        text: '面向工业、文娱、教育提供成熟的数智化解决方案 促进元宇宙应用落地、为产业提质增效'
      },
      {
        text: '2023 上海最具投资潜力50佳创业企业',
        color: '#D71819'
      },
      {
        text: '“创客中国”元宇宙（人工智能）',
        inlineBlock: true
      },
      {
        text: '专业赛一等奖',
        color: '#D71819',
        inlineBlock: true
      }
    ]
  },
  {
    name: '2024',
    content: [
      { text: '<span>旗下混空公司获评 </span><span style="color: #D71819">国家双软企业</span>' },
      { text: '<span>旗下混空公司获评 </span><span style="color: #D71819">上海软件核心竞争力企业</span>' },
      { text: '<span>旗下混空公司获评 </span><span style="color: #D71819">国家科技型中小企业</span>' },
      { text: '<span>旗下混空公司获评 </span><span style="color: #D71819">数字中国创新大赛数字文旅赛道优胜奖</span>' }
    ]
  },
  {
    name: '2025',
    content: [
      { text: '<span>旗下混空公司获评 </span><span style="color: #D71819">国家高新技术企业</span>' },
      { text: '<span>旗下混空公司 </span><span style="color: #D71819">数字人导航首发</span>' },
      { text: '<span>旗下混空公司 </span><span style="color: #D71819">混空AI大模型上线</span>' },
      { text: '<span>旗下混空公司 </span><span style="color: #D71819">自研采集软件上线</span>' },
      { text: '<span>旗下混空公司 </span><span style="color: #D71819">多个标杆文旅项目成功落地</span>' },
      { text: '<span>旗下混空公司 </span><span style="color: #D71819">多项元宇宙价值奖项斩获</span>' },
      { text: '<span style="color: #D71819">央视</span>等权威媒体报道' },
      { text: '多次亮相<span style="color: #D71819">国家级活动</span>' }
    ]
  }
]
const honors = [
  {
    url: require('/public/images/about-us/ryzz8.jpg'),
    illustrate: ['高新技术企业']
  },
  {
    url: require('/public/images/about-us/ryzz1.png'),
    illustrate: ['2023上海最具投资潜力', '50佳创业企业']
  },
  {
    url: require('/public/images/about-us/ryzz2.png'),
    illustrate: ['“创客中国”元宇宙（人工智能）', '专业赛 一等奖']
  },
  {
    url: require('/public/images/about-us/ryzz3.png'),
    illustrate: ['2023数智创新优胜奖']
  },
  {
    url: require('/public/images/about-us/ryzz4.png'),
    illustrate: ['诺亦腾年度最佳合作伙伴']
  },
  {
    url: require('/public/images/about-us/ryzz5.png'),
    illustrate: ['VIVE2023年度销量金牌']
  },
  {
    url: require('/public/images/about-us/ryzz6.png'),
    illustrate: ['与圆周率达成全国战略合作']
  },
  {
    url: require('/public/images/about-us/ryzz7.png'),
    illustrate: ['上海市创新创业大赛 优胜奖']
  },
]
const active_f_i = ref(0)
const honorsCarouselRef = ref<CarouselInstance>()

const prevEvent = () => {
  honorsCarouselRef.value?.prev()
}

const nextEvent = () => {
  honorsCarouselRef.value?.next()
}

onMounted(async () => {
  const shiming: any = await asynchronousRetrieval('nfznxr-images/about-us/shiming.png');
  const yuanjing: any = await asynchronousRetrieval('nfznxr-images/about-us/yuanjing.png');
  const jiazhiguan: any = await asynchronousRetrieval('nfznxr-images/about-us/jiazhiguan.png');
  const gongzhonghao: any = await asynchronousRetrieval('nfznxr-images/about-us/gongzhonghao.png');
  const shipinhao: any = await asynchronousRetrieval('nfznxr-images/about-us/shipinhao.png');
  const douyin: any = await asynchronousRetrieval('nfznxr-images/about-us/douyin.png');
  const xiaohongshu: any = await asynchronousRetrieval('nfznxr-images/about-us/xiaohongshu.png');
  const bilibili: any = await asynchronousRetrieval('nfznxr-images/about-us/bilibili.png');
  const weibo: any = await asynchronousRetrieval('nfznxr-images/about-us/weibo.png');
  const gsjs: any = await asynchronousRetrieval('nfznxr-images/about-us/gsjs.png');
  const fzlc_bg: any = await asynchronousRetrieval('nfznxr-images/about-us/fzlc-bg.png');
  const development_line: any = await asynchronousRetrieval('nfznxr-images/about-us/development-line.png');
  const qywh_bg: any = await asynchronousRetrieval('nfznxr-images/about-us/qywh-bg.png');
  const qywh: any = await asynchronousRetrieval('nfznxr-images/about-us/qywh.png');
  loadUrl.value = { shiming, yuanjing, jiazhiguan, gongzhonghao, shipinhao, douyin, xiaohongshu, bilibili, weibo, gsjs, fzlc_bg, development_line, qywh_bg, qywh }
})

</script>
<style scoped lang="less">
.about-us-mobile {
  display: block;
  width: 100%;
  overflow-x: hidden;
}

.title-font-style-m {
  width: 100%;
  box-sizing: border-box;
  font-weight: 600;
  font-size: 40rem;
  line-height: 56rem;
  color: #333333;
  font-family: PingFangSC-Medium;
  text-align: center;
}

.gsjs,
.szlc-box,
.ryzz,
.qywh,
.lxwm,
.zmt {
  width: 100%;
  box-sizing: border-box;
}

.gsjs {
  margin-top: 40rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 64rem;

  .content {
    width: calc(100% - 80rem);
    max-width: 620rem;
    height: auto;
    font-weight: 400;
    font-size: 24rem;
    color: #5D5D5D;
    line-height: 36rem;
    text-align: left;
    margin-top: 24rem;
  }

  .gsjs-img {
    width: calc(100% - 80rem);
    max-width: 680rem;
    height: auto;
    margin-top: 40rem;

    img {
      width: 100%;
    }
  }
}

.szlc-box {
  overflow: hidden;
  padding-top: 40rem;

  .szlc {
    position: relative;
    width: 100%;
    height: 166rem;
    margin-bottom: 30rem;
    margin-top: 24rem;
    padding-top: 54rem;
    box-sizing: border-box;
    overflow: hidden;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;

    &>img {
      width: 1241rem;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 0;
    }

    &>div {
      z-index: 1;
    }

    .development-line {
      position: relative;
      width: 1241rem;
      height: 2rem;
      background: url(/public/images/about-us/development-line.png);
      background-size: 100% 100%;
      padding: 0 190rem;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-weight: 600;
      font-size: 28rem;
      font-family: PingFangSC-Medium;
      z-index: 1;

      &>div {
        position: relative;
        color: #CF6464;

        &>div {
          position: absolute;
        }

        &>div:first-child {
          position: relative;
          position: absolute;
          left: -8rem;
          top: -8rem;
          width: 16rem;
          height: 16rem;
          background-color: #CF6464;
          border-radius: 100%;
          cursor: pointer;
        }

        &:hover,
        &.active-f {
          color: #D71819;

          &>div:first-child {
            background-color: #D71819;
          }

          &>div:first-child::after {
            content: '';
            position: absolute;
            left: calc(-9rem - 1px);
            top: calc(-9rem - 1px);
            width: 34rem;
            height: 34rem;
            border: 1px solid #D71819;
            border-radius: 50%;
          }
        }

        &>div:last-child {
          width: 54rem;
          height: 33rem;
          top: 37.5rem;
          left: -27rem;
          cursor: pointer;
        }
      }
    }
  }

  .szlc-content {
    width: calc(100% - 80rem);
    max-width: 620rem;
    margin: 0 auto;
    display: block;
    font-size: 0;

    &>div:first-child {
      padding: 0 0 18rem;
      font-weight: 600;
      font-size: 32rem;
      color: #D71819;
      font-family: PingFangSC-Medium;
      text-align: center;
      border-bottom: 1px solid #D5D5D5;
    }

    &>div:last-child {
      padding: 28rem 0 80rem;
      box-sizing: border-box;
    }

    .szlc-content-text {
      width: 100%;
      font-weight: 500;
      font-size: 24rem;
      color: #333333;
      text-align: left;
      line-height: 40rem;
      white-space: normal;
      word-break: break-all;
      font-family: PingFangSC-Medium;

      &>div {
        display: block !important;
        margin-bottom: 12rem;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}

.ryzz {
  position: relative;
  width: 100%;
  display: inline-block;

  .title-font-style-m {
    margin-bottom: 24rem;
  }

  .ryzz-list {
    position: relative;
    width: 100%;
    height: 340rem;
    margin-top: 24rem;
    overflow: hidden;
    z-index: 0;

    :deep(.el-carousel) {
      width: 100%;
    }

    :deep(.el-carousel__container) {
      height: 340rem !important;
    }

    :deep(.el-carousel__item) {
      height: 270rem;
      border-radius: 6rem;
      overflow: visible;
      top: 35rem;
      margin: 0;
      transition: transform .4s ease-in-out;
    }

    :deep(.el-carousel__item--card) {
      width: 232rem;
      left: calc(25% - 116rem);
      border: none;
      opacity: 0;
      visibility: hidden;
      pointer-events: none;
      transition: transform .4s ease-in-out, opacity .28s ease-in-out, visibility 0s linear .28s;
    }

    :deep(.el-carousel__item--card.is-in-stage),
    :deep(.el-carousel__item--card.is-active) {
      opacity: 1;
      visibility: visible;
      pointer-events: auto;
      transition: transform .4s ease-in-out, opacity .28s ease-in-out, visibility 0s linear 0s;
    }

    .honor-card {
      position: relative;
      width: 232rem;
      height: 270rem;
      border-radius: 6rem;
      padding-top: 10rem;
      box-sizing: border-box;
      text-align: center;
      border: 1px solid #D8D8D8;
      background-color: #fff;
      transform: scale(1);
      box-shadow: none;
      transition: transform .4s ease-in-out, box-shadow .4s ease-in-out;

      img {
        width: 147rem;
        height: 152rem;
        object-fit: contain;
      }

      &>div {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 68rem;
        padding: 15rem 0;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        box-sizing: border-box;
        background-color: #2E76FF;
        font-weight: bold;
        font-size: 14rem;
        color: #FFFFFF;
        border-radius: 0 0 8rem 8rem;
      }
    }

    :deep(.el-carousel__item.is-active) {
      z-index: 3;
    }

    :deep(.el-carousel__item.is-active .honor-card) {
      transform: scale(1.14);
      box-shadow: 0px 10rem 12rem 0px rgba(46, 118, 255, 0.2), 0px 0px 4rem 0px rgba(46, 118, 255, 0.2);
    }
  }

  .prev,
  .next {
    position: absolute;
    top: 246rem;
    width: 50rem;
    height: 50rem;
    padding: 0;
    cursor: pointer;
    z-index: 2;
  }

  .prev {
    background: url(/public/images/left.png);
    background-size: 100% 100%;
    left: 20rem;
  }

  .next {
    background: url(/public/images/right.png);
    background-size: 100% 100%;
    right: 20rem;
  }
}

.qywh {
  position: relative;
  width: 100%;
  padding-top: 20rem;
  box-sizing: border-box;

  &>img {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }

  .qywh-content {
    position: relative;
    width: 100%;
    height: 406rem;
    font-size: 0;
    margin-top: 24rem;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: flex-start;

    &>img {
      width: 100%;
      height: auto;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 0;
    }

    &>div {
      position: relative;
      width: calc(100% - 80rem);
      max-width: 680rem;
      height: 362rem;
      background: #F7F7F7;
      border-radius: 8rem;
      padding: 40rem 0 40rem 52rem;
      box-sizing: border-box;
      font-weight: 400;
      font-size: 20rem;
      color: #414141;
      text-align: left;
      z-index: 1;

      .q1 {
        font-weight: 600;
        font-size: 24rem;
        color: #D71819;
        font-family: PingFangSC-Medium;
        margin-bottom: 10rem;

        img {
          width: 30rem;
          height: 30rem;
          vertical-align: middle;
          margin-right: 11rem;
        }

        span {
          vertical-align: middle;
        }
      }

      .q2 {
        padding-left: 41rem;
        margin-bottom: 30rem;
      }
    }
  }
}

.lxwm {
  position: relative;
  margin-top: 26rem;

  .lxwm-content {
    width: calc(100% - 80rem);
    max-width: 670rem;
    font-weight: 400;
    font-size: 14rem;
    color: #333333;
    text-align: left;
    padding-left: 0;
    margin-left: auto;
    margin-right: auto;
    margin-top: 52rem;

    &>div {
      display: block;
      width: 100%;
      margin-left: 0 !important;
      margin-bottom: 48rem;
    }

    &>div:first-child {
      width: 100%;
    }

    .s1 {
      font-weight: 600;
      font-size: 32rem;
      color: #000000;
      font-family: PingFangSC-Medium;
      margin-bottom: 9rem;
    }

    .s2 {
      font-weight: 600;
      font-size: 24rem;
      color: #D71819;
      font-family: PingFangSC-Medium;
      margin-bottom: 20rem;
    }

    .s3 {
      font-weight: 400;
      font-size: 20rem;
      color: #000000;
      line-height: 20rem;
      margin-bottom: 16rem;
    }
  }
}

.zmt {
  position: relative;
  margin-top: 70rem;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 72rem;

  &>div:first-child {
    width: 100%;
    text-align: center;
    position: absolute;
    left: 0;
    top: 0;
  }

  .zmt-content {
    width: calc(100% - 80rem);
    max-width: 680rem;
    border-radius: 8rem;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    box-sizing: border-box;
    margin: 0 0 40rem;
    border-radius: 8rem;
    overflow: hidden;

    &>div {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      font-weight: 400;
      font-size: 14rem;
      padding: 30rem 54rem;
      box-sizing: border-box;
      font-size: 24rem;
      background: rgba(215, 24, 25, 0.03);

      &>div {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }

      img {
        width: 223rem;
        height: 223rem;
        margin-bottom: 20rem;
      }
    }
  }
}
</style>
